export default __webpack_public_path__ + "static/icon-5dc58a4d3c20e03df2aa3feee9485e52.png";